import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IFile } from "../../interfaces";
import { uploadFilesAction } from "../../redux/UserSlice";
import { RootState } from "../../redux/store";

export interface IFileUploaderState {
  files: IFile[];
  dragOver: boolean;
  msg: string | null;
  err_msg: null | string;
  isLoading: boolean;
}
export const FileUploaderState: IFileUploaderState = {
  files: [],
  dragOver: false,
  err_msg: null,
  msg: null,
  isLoading: false,
};

export const FileUploaderSlice = createSlice({
  name: "FileUploaderSlice",
  initialState: FileUploaderState,
  reducers: {
    setFilesErrMsg: (state, action: PayloadAction<string | null>) => {
      state.err_msg = action.payload;
    },
    setFilesMsg: (state, action: PayloadAction<string | null>) => {
      state.msg = action.payload;
    },

    setFiles: (state, action: PayloadAction<IFile[]>) => {
      state.files = action.payload;
    },
    removeFile: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      const newFiles: IFile[] = state.files!.filter((v, i) => i !== index);
      state.files = newFiles;
    },
    setDragOver: (state, action: PayloadAction<boolean>) => {
      state.dragOver = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFilesAction.fulfilled, (state, action) => {
        const { result } = action.payload;
        if (!result) {
          return;
        }
        state.files = [];
        state.isLoading = false;
      })
      .addCase(uploadFilesAction.rejected, (state, action: any) => {
        if (action.error.message === "Request failed with status code 401") {
          state.err_msg = "Session timeout. Please login again.";
        }
        state.isLoading = false;
      })
      .addCase(uploadFilesAction.pending, (state, action) => {
        state.isLoading = true;
      });

  },
});

export const {
  setFiles,
  setDragOver,
  setFilesErrMsg,
  setFilesMsg,
  removeFile,
} = FileUploaderSlice.actions;

export const selectFiles = (state: RootState) => state.FileUploaderSlice.files;
export const selectDragOver = (state: RootState) =>
  state.FileUploaderSlice.dragOver;
export const selectIsLoading = (state: RootState) =>
  state.FileUploaderSlice.isLoading;
export const selectErrMsgFiles = (state: RootState) =>
  state.FileUploaderSlice.err_msg;
export const selectFilesMsg = (state: RootState) => state.FileUploaderSlice.msg;

export default FileUploaderSlice.reducer;
